import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { useEffect } from "react";
import classes from "./Banner.module.css";
const Banner = (props) => {
  let isLoaded = props.bannerData !== null;

  // useEffect(() => {
  //     if (!isLoaded) {
  //         console.log("banner fetch request sent to server")
  //         props.fetchBanner();
  //     }
  // }, []);

  //   if (!isLoaded) {
  //     return null;
  //   }
  //   if (!(props.bannerData.length > 0)) {
  //     return null;
  //   }
  if (!props.banner) {
    return null;
  }
  return (
    <>
      <div className={`jumbotron jumbotron ${classes.BannerDiv}`}>
        <a href={props.banner.redirectUrl} target="_blank">
          <img
            className={`card-img-top ${classes.BannerImage}`}
            src={props.banner.imgUrl}
            alt={props.banner.imgTitle}
          ></img>
        </a>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    bannerData: state.banner.bannerData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBanner: () => dispatch(actions.fetchBanner()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Banner);
